import MeetingResult from './meetingResult.view';

export default MeetingResult;
